import { createFileRoute, redirect } from "@tanstack/react-router";

// Združeno pod /navdih — obdrži URL kot 301 preusmeritev za zunanje povezave.
export const Route = createFileRoute("/ideje-in-navdih")({
  beforeLoad: () => {
    throw redirect({ to: "/navdih", statusCode: 301 });
  },
});
